import {Evaluator} from "@cm/graph-v3"
import {registerImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/register-image-op-node"
import {
    AnyImageOpContext,
    AnyImageOpResult,
    ImageOpOutputs,
    ValueOrNode,
} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {Definition} from "@app/textures/texture-editor/operator-stack/operators/test/node/definition"
import {ImageOpNodeBag} from "@app/textures/texture-editor/operator-stack/image-op-system/helpers/image-op-node-bag"
import {ImageOpNodeBlit} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/blit/node"
import {ImageOpNodeResize} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/resize/node"
import {ImageOpNodeExtractRegion} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/extract-region/node"
import {CompositeImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/composite-image-op-node"

const nodeDefinition = {...Definition, nodeClass: "OperatorTestNode"}

@registerImageOpNode
export class OperatorTestNode extends CompositeImageOpNode<typeof Definition> {
    override get definition() {
        return nodeDefinition
    }

    override async execute(evaluator: Evaluator<AnyImageOpContext>, imageOpNodeBag: ImageOpNodeBag): Promise<ImageOpOutputs<typeof Definition>> {
        const {sourceImage, param0, param1, param2} = await evaluator.getAll(this.parameters)
        let imageOp: ValueOrNode<AnyImageOpResult> = sourceImage
        // imageOp = convert-to-grayscale({
        //     sourceImage: imageOp,
        //     mode: "luminance",
        // })
        // imageOp = blend({
        //     backgroundImage: sourceImage,
        //     foregroundImage: imageOp,
        //     alpha: this.param0.value,
        //     blendMode: "normal",
        //     premultipliedAlpha: false,
        // })

        // const getRandomInt = (min: number, max: number): number => {
        //     return Math.floor(Math.random() * (max - min + 1)) + min
        // }
        // imageOp = this.mandelbrot = nodeWithParameters(this.mandelbrot, ImageOpMandelbrot, {
        //     descriptor: {
        //         width: getRandomInt(100, 1000),
        //         height: getRandomInt(100, 1000),
        //         channels: 3,
        //     },
        // })
        // imageOp = this.reduce = nodeWithParameters(this.reduce, ImageOpReduce, {
        //     sourceImage: imageOp,
        //     operator: "sum",
        // })

        // const scale = 1024 * 512 + 1
        // const scale = 500000
        // imageOp = this.mandelbrot = nodeWithParameters(this.mandelbrot, ImageOpNodeMandelbrot, {
        //     descriptor: {
        //         width: scale,
        //         height: scale,
        //         channels: 3,
        //     },
        // })
        // const originalImage = imageOp

        // imageOp = this.rotateVectorMap.getGraph({
        //     sourceImage: imageOp,
        //     angleInDegrees: this.param0.value * 360,
        // })
        // imageOp = imageOpNodeBag.getNode("rotateVectorMap", ImageOpNodeRotateVectorMap, {
        //     sourceImage: imageOp,
        //     angleInDegrees: param0 * 360,
        // })

        // imageOp = this.downSample = nodeWithParameters(this.downSample, ImageOpNodeDownSample, {
        //     sourceImage: imageOp,
        // })

        // const b = this.createLaplacianPyramid.getGraph({
        //     sourceImage: imageOp,
        //     sigma: 1,
        // })
        // let a: ImageOpNode[]
        // switch (Math.floor(this.param1.value * 3)) {
        //     case 0:
        //         a = b.gaussianPyramid
        //         break
        //     case 1:
        //         a = b.upSampledGaussianPyramid
        //         break
        //     case 2:
        //     default:
        //         a = b.laplacianPyramid
        //         break
        // }
        // const level = Math.min(a.length - 1, Math.floor(this.param0.value * b.laplacianPyramid.length))
        // // imageOp = a[level]
        // imageOp = this.resize = nodeWithParameters(this.resize, ImageOpNodeResize, {
        //     sourceImage: a[level],
        //     resultSize: {
        //         width: imageOp.descriptor.width,
        //         height: imageOp.descriptor.height,
        //     },
        // })

        // const scaledSourceImage = (this.resize = nodeWithParameters(this.resize, ImageOpNodeResize, {
        //     sourceImage: sourceImage,
        //     resultSize: imageOp.descriptor,
        // }))

        // const mask = imageOpNodeBag.getNode("colorGradient", ImageOpNodeColorGradient, {
        //     descriptor: {
        //         ...sourceImage.descriptor,
        //         channels: 1,
        //     },
        //     type: "linear",
        //     startPos: {
        //         x: 0,
        //         y: 0,
        //     },
        //     endPos: {
        //         x: 0,
        //         y: sourceImage.descriptor.height,
        //     },
        //     stops: [
        //         {t: 0, color: 0},
        //         {t: 0.499999, color: 0},
        //         {t: 0.500001, color: 1},
        //         {t: 1, color: 1},
        //     ],
        // })
        // // imageOp = this.blendByLaplacianPyramid.getGraph({
        // //     backgroundImage: imageOp,
        // //     foregroundImage: scaledSourceImage,
        // //     maskImage: mask,
        // // })
        // imageOp = imageOpNodeBag.getNode("blendByLaplacianPyramidNode", ImageOpNodeBlendByLaplacianPyramid, {
        //     backgroundImage: imageOp,
        //     foregroundImage: originalImage, //scaledSourceImage,
        //     maskImage: mask,
        //     testParam1: param1,
        //     testParam2: param2,
        //     // wrapAround: param1 > 0.5,
        // })

        // imageOp = imageOpNodeBag.getNode("testNode", ImageOpNodeTest, {
        //     sourceImage: imageOp,
        //     param0: param0,
        //     param1: param1,
        //     param2: param2,
        // })

        const originalSize = {
            width: imageOp.descriptor.width,
            height: imageOp.descriptor.height,
        }

        // const white = imageOpNodeBag.getNode("white", ImageOpNodeColorGradient, {
        //     descriptor: {
        //         width: 10,
        //         height: 10,
        //         channels: 3,
        //     },
        //     startPos: {x: 0, y: 0},
        //     endPos: {x: 10, y: 10},
        //     stops: [
        //         {t: 0, color: 0},
        //         {t: 1, color: 1},
        //     ],
        //     type: "linear",
        // })
        // const position = {x: Math.round(param0 * originalSize.width), y: Math.round(param1 * originalSize.height)}
        const position = {x: 20 + param0, y: param1} //{x: 2040, y: 2050}
        // imageOp = imageOpNodeBag.getNode("blit", ImageOpNodeBlit, {
        //     backgroundImage: imageOp,
        //     foregroundImage: white,
        //     position,
        // })

        const s = Math.max(0.01, 1 - param2)
        imageOp = imageOpNodeBag.getNode("downScale", ImageOpNodeResize, {
            sourceImage: imageOp,
            resultSize: {
                width: Math.round(originalSize.width * s),
                height: Math.round(originalSize.height * s),
            },
            interpolationMode: "cubic",
        })

        const white = imageOpNodeBag.getNode("white", ImageOpNodeExtractRegion, {
            sourceImage: imageOp,
            region: {
                ...position,
                // x: 20,
                // y: 0,
                width: 10,
                height: 10,
            },
        })
        imageOp = imageOpNodeBag.getNode("blit", ImageOpNodeBlit, {
            backgroundImage: imageOp,
            foregroundImage: white,
            position,
        })

        imageOp = imageOpNodeBag.getNode("upScale", ImageOpNodeResize, {
            sourceImage: imageOp,
            resultSize: originalSize,
            interpolationMode: "nearest", // "cubic",
        })

        // imageOp = imageOpNodeBag.getNode("shift", ImageOpNodeAffineTransform, {
        //     sourceImage: imageOp,
        //     resultSize: originalSize,
        //     addressMode: "wrap",
        //     transform: new Matrix3x2().translate(new Vector2(200, 0)),
        // })

        // imageOp = this.gaussianBlur.getGraph({
        //     sourceImage: imageOp,
        //     sigma: this.param0.value * scale * 0.1,
        //     borderMode: "renormalize",
        // })

        // imageOp = this.math0 = nodeWithParameters(this.math0, ImageOpMath, {
        //     operator: "+",
        //     operandA: imageOp,
        //     operandB: this.param0.value,
        // })
        // imageOp = this.math1 = nodeWithParameters(this.math1, ImageOpMath, {
        //     operator: "pow",
        //     operandA: imageOp,
        //     operandB: 2,
        // })
        // imageOp = this.math2 = nodeWithParameters(this.math2, ImageOpMath, {
        //     operator: "-",
        //     operandA: imageOp,
        //     operandB: 0.25,
        // })
        // imageOp = this.convert-to-grayscale = nodeWithParameters(this.convert-to-grayscale, ImageOpToGrayscale, {
        //     sourceImage: imageOp,
        //     mode: this.param0.value > 0.5 ? "luminance" : "average",
        // })

        // imageOp = this.affineTransform = nodeWithParameters(this.affineTransform, ImageOpNodeAffineTransform, {
        //     sourceImage: imageOp,
        //     transform: new Matrix3x2().rotate(this.param1.value * 360, Vector2.fromSize2Like(imageOp.descriptor).mul(0.5)),
        //     resultSize: imageOp.descriptor,
        // })

        // const scale = 2
        // imageOp = this.rasterizeGeometry = nodeWithParameters(this.rasterizeGeometry, ImageOpNodeRasterizeGeometry, {
        //     descriptor: imageOp.descriptor,
        //     textureImage: imageOp,
        //     geometry: {
        //         topology: "triangleList",
        //         vertices: {
        //             positions: [
        //                 new Vector2(0, 0),
        //                 new Vector2(imageOp.descriptor.width, 0),
        //                 new Vector2(imageOp.descriptor.width, imageOp.descriptor.height),
        //                 new Vector2(0, imageOp.descriptor.height),
        //             ],
        //             uvs: [
        //                 new Vector2(0, 0),
        //                 new Vector2(imageOp.descriptor.width * scale, 0),
        //                 new Vector2(imageOp.descriptor.width * scale, imageOp.descriptor.height * scale),
        //                 new Vector2(0, imageOp.descriptor.height * scale),
        //             ],
        //         },
        //         indices: [0, 1, 2, 0, 2, 3],
        //     },
        // })

        // imageOp = this.drawableImage = nodeWithParameters(this.drawableImage, ImageOpNodeDrawableImage, {
        //     descriptor: {
        //         width: imageOp.descriptor.width,
        //         height: imageOp.descriptor.height,
        //         channels: 1,
        //     },
        // })

        // imageOp = imageOpNodeBag.getNode("showTiles", ImageOpNodeShowTiles, {
        //     sourceImage: imageOp,
        // })

        // imageOp = imageOpNodeBag.getNode("rasterize", ImageOpNodeRasterizeGeometry, {
        //     descriptor: {
        //         width: 3000,
        //         height: 3000,
        //         channels: 3,
        //     },
        //     geometry: {
        //         topology: "triangleList",
        //         vertices: {
        //             positions: new Float32Array([1000, 1000, 1000, 2000, 2000, 2000, 2000, 1000]),
        //             // positions: new Float32Array([1500, 1000, 1000, 1500, 1500, 2000, 2000, 1500]),
        //             uvs: new Float32Array([1000, 1000, 1000, 8000, 8000, 8000, 8000, 1000]),
        //             colors: new Float32Array([0, 0, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1]),
        //         },
        //         indices: new Uint32Array([0, 1, 3, 3, 1, 2]),
        //     },
        //     // worldTransform: new Matrix3x2().rotate(1),
        //     addressMode: "clamp",
        //     textureImage: this.sourceImage,
        // })

        return await evaluator.get(imageOp)
    }
}
